import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgArrowRight = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 11,
	height: 18,
	viewBox: "0 0 11 18",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("g", {
		clipPath: "url(#clip0_272_4)",
		children: /* @__PURE__ */ _jsx("path", {
			d: "M10.3418 8.96484L10.3438 8.96582L10.3428 8.9668L10.3438 8.96777H10.3418L5.83984 18H1.34375L5.79589 8.96875L1.36035 0H5.83593L10.3418 8.96484Z",
			fill: "#001E50"
		})
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_272_4",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 10,
			height: 18,
			fill: "white",
			transform: "translate(0.5)"
		})
	}) })]
});
export default SvgArrowRight;
